import PropTypes from "prop-types";
import React, { Component } from "react";
import DragLayer from "react-dnd/lib/DragLayer";
import itemViews from "components/items/views";
import Separator from "components/items/separator";
import { merge, $ } from "glamor";
import ImageIcon from "components/icons/image";

function collect(monitor) {
    const item = monitor.getItem() || {};
    return {
        catalogEntry: item.catalogEntry,
        item: item.item,
        cart: item.cart,
        viewDef: item.viewDef,
        activeList: item.activeList,
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging(),
        type: item.type,
    };
}

class ItemPreview extends Component {
    static propTypes = {
        currentOffset: PropTypes.shape({
            x: PropTypes.number,
            y: PropTypes.number,
        }),
        isDragging: PropTypes.bool,
    };

    styles = {
        pointerEvents: "none",
        zIndex: 2000,
        position: "fixed",
        top: 0,
        left: 0,
    };

    style = merge(
        $(" .imagePlaceholder", {
            width: "300px",
            height: "50px",
        })
    );

    shouldComponentUpdate(nextProps) {
        return nextProps.catalogEntry !== this.props.catalogEntry || nextProps.isDragging !== this.props.isDragging;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this._container && nextProps.currentOffset) {
            const { x, y } = nextProps.currentOffset;
            const transform = `translate(${x}px, ${y}px)`;
            this._container.style.transform = transform;
            this._container.style.WebkitTransform = transform;
        }
    }

    render() {
        const {
            isDragging,
            view,
            activeBrand,
            item,
            catalogEntry,
            viewDef,
            activeList,
            onSnackbarAdd,
            cart,
            type,
            scope,
            actionsOffset,
            editable,
            list,
        } = this.props;

        let content = null;

        if (isDragging) {
            const isSeparator = catalogEntry && catalogEntry.type === "separator";
            if (isSeparator) {
                content = <Separator width={200} catalogEntry={catalogEntry} onSnackbarAdd={onSnackbarAdd} />;
            } else if (type === "separator") {
                content = <Separator width={200} catalogEntry={{}} onSnackbarAdd={onSnackbarAdd} />;
            } else if (type === "image") {
                content = (
                    <div className="imagePlaceholder">
                        <ImageIcon />
                    </div>
                );
            } else if (item) {
                const View = itemViews[view][0];

                content = (
                    <View
                        activeBrand={activeBrand}
                        item={item}
                        cart={cart}
                        catalogEntry={catalogEntry}
                        activeList={activeList}
                        view={viewDef}
                        onSnackbarAdd={onSnackbarAdd}
                        scope={scope}
                        actionsOffset={actionsOffset}
                        editable={editable}
                        list={list}
                    />
                );
            }
        }
        return (
            <div ref={(ref) => (this._container = ref)} style={this.styles} {...this.style}>
                {content}
            </div>
        );
    }
}

export default DragLayer(collect)(ItemPreview);
